import * as React from 'react'
import {Link} from 'react-router-dom'
import { connect } from 'react-redux'

import {Button, TYPES} from './../shared/button'
import Modal from './../shared/modal'
import ReportOptions from './reportOptions'
import ViewNotes from './../note/viewNotes'

import './../../styles/recordings/recordings.css'
import './../../styles/shared/modal.css'

import strftime from 'strftime';

class RecordingData extends React.Component {
  constructor() {
    super()

    this.state = {
      modal: false,
      data: false,
      component: null,
      notes: null,
      license_plate: null,
      reportOptions: false,
      unknownLicensePlate: false
    }
  }

  licensePlateCheck = (num) => {
    if(num === null) {
      return 'No Plate Read'
    } else {
      return num
    }
  }

  toggleModal = (component, notes, license_plate) => {
    this.setState({ modal: !this.state.modal });
    if(component === 1) {
      this.setState({component: 1})
    } else {
      this.setState({notes: notes, license_plate: license_plate})
      this.setState({component: 2})
    }
  }

  displayComponent = () => {
    if(this.state.component === 1) {
      return <ReportOptions />
    } else if(this.state.component === 2){
      return <ViewNotes notes={this.state.notes} license_plate={this.state.license_plate} />
    }
  }

  noteCheck = (num, notes, license_plate) => {
    if(num > 0) {
      return (
        <div>
        {this.state.reportOptions &&
          <Button
            text='Report Options'
            type='recordingsAction'
            onClick={() => {this.toggleModal(1)}}
            buttonType={TYPES.DEFAULT}
          />
        }
          <Button
            text='View Notes'
            type='recordingsAction'
            onClick={() => {this.toggleModal(2, notes, license_plate)}}
            buttonType={TYPES.DEFAULT}
          />
        </div>
      )
    }
  }

  render () {
    const { modal } = this.state
    const { visits } = this.props.visits
    const showLocations = this.props.auth.user.locations.length > 1
    return (
      <div>
        <table className='recordings-table'>
          <thead>
            <tr>
              <th className='recordings-table-header'>License</th>
              <th className='recordings-table-header'>Date</th>
              {showLocations && <th className='recordings-table-header'>Location</th>}
              <th className='recordings-table-header'>Bay</th>
              <th className='recordings-table-header'>Notes</th>
              <th className='recordings-table-header'>Action</th>
            </tr>
          </thead>
          <tbody>
            { visits.map((visit, index)=> {
              return(
                <tr className='recordings-row' key={"recording" + index}>
                  <td className='recording-indent'>{this.licensePlateCheck(visit.license_plate)}</td>
                  <td className='recording-indent'>{strftime('%B %d, %Y %I:%M %p', new Date(visit.triggered_at))}</td>
                  {showLocations && <td align='center'>{visit.location_name}</td>}
                  <td align='center'>{visit.bay_number}</td>
                  <td align='center'>{visit.notes.length}</td>
                  <td id='recording-action'>
                    <div className='note-check'>
                      <Link to={`/visits/${visit.id}`}>
                        <Button
                          text='Review Footage'
                          type='recordingsAction'
                          buttonType={TYPES.DEFAULT}
                        />
                      </Link>
                      {this.noteCheck(visit.notes.length, visit.notes, visit.license_plate)}
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>

        {modal &&
          <Modal onCloseRequest={() => this.toggleModal()}>
            {this.displayComponent()}
          </Modal>}

      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

export default connect(mapStateToProps)(RecordingData);



// WEBPACK FOOTER //
// ./src/components/recordings/recordingData.js